export default config => {
  const configUpdate = config;
  configUpdate.url = `http://localhost:3001${config.url}`;
  return configUpdate;
};
